import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Switch } from '../../components/ui/switch';
import { Save, Loader2 } from 'lucide-react';

const SERVICE_BORDERS = {
  day_program: 'border-[#9B7ED8] bg-[#EDE7F6]/30',
  in_home: 'border-[#81C784] bg-[#E8F5E9]/30',
  employment: 'border-[#FFB74D] bg-[#FFF3E0]/30',
};

export default function ServicesTab({ settings, setSettings, updateService, saving, saved, handleSaveSettings }) {
  const services = settings.services || {};
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Button onClick={handleSaveSettings} disabled={saving} className="bg-[#6B3FA0] hover:bg-[#5A2F8E] text-white gap-2" data-testid="save-settings-btn">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
          {saved ? 'Saved!' : saving ? 'Saving...' : 'Save Settings'}
        </Button>
      </div>

      <Card className="border-[#DED8EB] shadow-sm bg-white">
        <CardHeader className="pb-3">
          <CardTitle className="text-lg font-semibold text-[#2D1B4E]" style={{ fontFamily: 'Manrope, sans-serif' }}>General</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="max-w-xs space-y-2">
            <Label className="text-[#2D1B4E] font-medium">Default Weekly Hours Cap</Label>
            <Input type="number" value={settings.default_weekly_cap || 40} onChange={e => setSettings(p => ({ ...p, default_weekly_cap: parseFloat(e.target.value) || 40 }))}
              className="border-[#DED8EB] w-32" data-testid="default-weekly-cap" />
            <p className="text-xs text-[#8E85A0]">Applied to new staff. Individual caps on the Staff page.</p>
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {Object.entries(services).map(([key, svc]) => (
          <Card key={key} className={`border shadow-sm ${SERVICE_BORDERS[key] || ''}`} data-testid={`settings-${key}`}>
            <CardHeader className="pb-3">
              <CardTitle className="text-lg font-semibold text-[#2D1B4E]" style={{ fontFamily: 'Manrope, sans-serif' }}>{svc.label}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-2">
                <Label className="text-[#2D1B4E] font-medium text-sm">Staff needed per day</Label>
                <Input type="number" value={svc.slots_needed} onChange={e => updateService(key, 'slots_needed', parseInt(e.target.value, 10) || 0)}
                  className="border-[#DED8EB] bg-white w-24" data-testid={`${key}-slots`} />
              </div>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-2">
                  <Label className="text-[#2D1B4E] font-medium text-sm">Default Time In</Label>
                  <Input type="time" value={svc.default_time_in} onChange={e => updateService(key, 'default_time_in', e.target.value)}
                    className="border-[#DED8EB] bg-white" style={{ fontFamily: 'IBM Plex Mono, monospace' }} data-testid={`${key}-time-in`} />
                </div>
                <div className="space-y-2">
                  <Label className="text-[#2D1B4E] font-medium text-sm">Default Time Out</Label>
                  <Input type="time" value={svc.default_time_out} onChange={e => updateService(key, 'default_time_out', e.target.value)}
                    className="border-[#DED8EB] bg-white" style={{ fontFamily: 'IBM Plex Mono, monospace' }} data-testid={`${key}-time-out`} />
                </div>
              </div>
              <div className="space-y-2">
                <Label className="text-[#2D1B4E] font-medium text-sm">Staff:Participant Ratio</Label>
                <Input value={svc.ratio} onChange={e => updateService(key, 'ratio', e.target.value)}
                  className="border-[#DED8EB] bg-white w-24" data-testid={`${key}-ratio`} />
              </div>
              <div className="flex items-center gap-3">
                <Switch checked={svc.fixed_time} onCheckedChange={v => updateService(key, 'fixed_time', v)} data-testid={`${key}-fixed-time`} />
                <Label className="text-sm text-[#5A4D6E]">Fixed time (no custom hours)</Label>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
